import styled from 'styled-components';
import { palette } from 'styled-theme';

export const Tab = styled.button`
  padding: 6px 18px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '600' : '400')};
  cursor: pointer;
  background: ${({ $active }) =>
    $active ? 'linear-gradient(90deg, #7b5cff, #60a5fa)' : 'transparent'};
  color: ${({ $active }) => ($active ? '#fff' : '#666')};
  box-shadow: ${({ $active }) => ($active ? '0 1px 4px rgba(0,0,0,0.10)' : 'none')};

  &:hover {
    background: ${({ $active }) =>
      $active ? 'linear-gradient(90deg, #7b5cff, #60a5fa)' : 'rgba(0,0,0,0.06)'};
  }
`;

export const TabWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${({ theme }) => theme?.palette?.background};
  border-radius: 8px;
  padding: 4px;
  border: 1px solid ${palette('border', 1)};
`;
